import Row from './row';
import Col from './col';
export { Row, Col };
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./node_modules/antd/es/grid/index.js